module.exports = __webpack_public_path__ + "img/thumb_13.816fb200.jpg";